<template>
  <el-dialog
    title="编辑技师"
    :visible.sync="dialogVisible"
    @close='dialogFormVisible'
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="姓名" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="照片" prop="image_id" :label-width="formLabelWidth">
        <div>
          <el-button type="primary" @click="openUpload">上传图片</el-button>
          <img class="mt10" v-img-url="'image.file_path',form"  width="120px;" alt="" />
          <!--上传图片组件-->
          <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
        </div>
      </el-form-item>
      <el-form-item label="邮箱" prop="email" :label-width="formLabelWidth">
        <el-input v-model="form.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile" :label-width="formLabelWidth">
        <el-input v-model="form.mobile" autocomplete="off" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
        <el-select v-model="form.status" placeholder="请选择状态">
          <el-option label="在职(占用名额)" :value="10"></el-option>
          <el-option label="归档(不占名额)" :value="20"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="从业年限" prop="experience_years" :label-width="formLabelWidth">
        <el-input-number v-model="form.experience_years" :min="0" :max="99" controls-position="right"></el-input-number>
        <span style="margin-left:8px;color:#909399;">年（顾客端展示，0 或留空不展示）</span>
      </el-form-item>
      <el-form-item label="擅长项目" prop="good_at" :label-width="formLabelWidth">
        <el-input v-model="form.good_at" maxlength="100" placeholder="如：深层指压、热石按摩"></el-input>
      </el-form-item>
      <el-form-item label="服务风格" prop="service_style" :label-width="formLabelWidth">
        <el-input v-model="form.service_style" maxlength="100" placeholder="如：专业细致、手法沉稳"></el-input>
      </el-form-item>
      <el-form-item label="个人简介" prop="intro" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.intro" maxlength="200" show-word-limit :rows="3" placeholder="顾客端展示的技师介绍，限 200 字"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.remark" placeholder="后台内部备注，不展示给顾客"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
      </div>
    </template>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="'image'" @returnImgs="returnImgsFunc">
    </Upload>
  </el-dialog>
</template>

<script>
import TechnicianApi from '@/api/technician/technician.js';
import Upload from '@/components/file/Upload.vue';
export default {
  components: {
    Upload
  },
  data() {
    return {

      formRules: {
        name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }
        ],
        image_id: [
          {
            required: true,
            message: '请上传图片',
            trigger: 'blur'
          }
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ]
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: true,
      loading: false,
      /*是否上传图片*/
      isupload: false,
      file_path: '',
      /*保存原始状态，用于检查状态变更*/
      originalStatus: null,
    };
  },
  props: ['open_edit', 'form', 'subscription'],
  created() {
    this.dialogVisible = this.open_edit;
    this.form.technician_id = this.form.technician_id;
    this.form.name = this.form.name;
    this.form.image_id = this.form.image_id;
    this.form.email = this.form.email || '';
    this.form.mobile = this.form.mobile || '';
    // 保存原始状态
    this.originalStatus = this.form.status || 10;
    this.form.status = this.form.status || 10;
    // 展示字段回填（兼容历史数据为空）
    this.$set(this.form, 'experience_years', this.form.experience_years || 0);
    this.$set(this.form, 'good_at', this.form.good_at || '');
    this.$set(this.form, 'service_style', this.form.service_style || '');
    this.$set(this.form, 'intro', this.form.intro || '');
    this.form.remark = this.form.remark;
    this.file_path = this.form.image_url;
  },
  methods: {
    /**
     * 编辑技师
     */
    editUser() {
      let self = this;
      let params = self.form;

      // 检查状态变更：如果从"归档(20)"改为"在职(10)"，需要检查名额
      const oldStatus = self.originalStatus; // 原始状态
      const newStatus = params.status; // 新状态

      // 核心判断：只有当"旧状态非在职" 且 "新状态是在职" 时，才检查限额
      if (oldStatus != 10 && newStatus == 10) {
        // 检查名额是否已满
        if (self.subscription && self.subscription.used >= self.subscription.limit) {
          self.showQuotaFullModal();
          return;
        }
      }

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          TechnicianApi.edit(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    /**
     * 显示名额已满引导弹窗
     */
    showQuotaFullModal() {
      this.$confirm('当前套餐技师名额已满，无法添加或启用技师。<br>请购买额外名额，即买即用。', '名额不足', {
        confirmButtonText: '去购买名额',
        cancelButtonText: '暂不购买',
        type: 'warning',
        dangerouslyUseHTMLString: true // 允许换行
      }).then(() => {
        // 关闭编辑弹窗
        this.dialogFormVisible(false);
        // 跳转到订阅管理页面，并自动切换到"购买名额"Tab
        this.$router.push({
          path: '/setting/subscription/index',
          query: { tab: 'addStaff' }
        });
      }).catch(() => {
        // 用户取消，不做任何操作
      });
    },

    /**
     * 关闭弹窗
     * @param {boolean} e
     */
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          open: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          open: false
        });
      }
    },

    /**
     * 打开上传图片
     */
    openUpload(){
      this.isupload = true;
    },

    /**
     * 上传图片
     * @param {Array} e
     */
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image.file_path = e[0].file_path;
      }
      this.isupload = false;
    },

  }
};
</script>

<style>
.img{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/technician/Edit.vue